import { variousAsn } from '../../../common/constants';
import { ManifestPackageStatus } from '../../../common/status';
import { ManifestProps } from '../../../datastore/tripSheets';

const lockedPackageStatuses = new Set<string>([
  ManifestPackageStatus.qm,
  ManifestPackageStatus.direct,
  ManifestPackageStatus.qm_pending,
  ManifestPackageStatus.direct_pending
]);

export function normalizeManifestPackageStatuses(sourceManifest: ManifestProps): ManifestProps {
  const normalizedSsccs = sourceManifest.ssccs.map((sscc) => {
    const normalizedPackages = sscc.packages.map((pkg) => {
      if (pkg.asn === variousAsn || lockedPackageStatuses.has(pkg.receivedStatus)) {
        // VARIOUS and locked workflow statuses are not quantity-derived.
        return pkg;
      }

      return {
        ...pkg,
        receivedStatus:
          pkg.quantity <= 0
            ? ManifestPackageStatus.notReceived
            : pkg.quantity >= pkg.maxQuantity
              ? ManifestPackageStatus.received
              : ManifestPackageStatus.partial
      };
    });

    return {
      ...sscc,
      packages: normalizedPackages
    };
  });

  return {
    ...sourceManifest,
    ssccs: normalizedSsccs
  };
}
